import { render, staticRenderFns } from "./KoreanairSkypass.vue?vue&type=template&id=0120147b&scoped=true"
import script from "./KoreanairSkypass.vue?vue&type=script&lang=js"
export * from "./KoreanairSkypass.vue?vue&type=script&lang=js"
import style0 from "./KoreanairSkypass.vue?vue&type=style&index=0&id=0120147b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0120147b",
  null
  
)

export default component.exports